import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DsBannerState, DsBannerModule } from '@levelaccess/design-system';
import { SharedModule } from '../../shared/shared.module';

@Component({
  selector: 'app-userway-sso-error-banner',
  templateUrl: './userway-sso-error-banner.component.html',
  standalone: true,
  imports: [SharedModule, DsBannerModule],
})
export class UserWaySsoErrorBannerComponent {
  protected readonly DsBannerState: typeof DsBannerState = DsBannerState;
  @Input() public isVisible: boolean = false;
  @Output() public closed: EventEmitter<void> = new EventEmitter<void>();
}
